import { useMutation } from 'react-query';

import { makeFetchCustomerByIdUseCase } from 'modules/checkin/domain/useCases';
import { ICustomer } from 'shared/domain/entities';

type TParams = {
  onError?: (error: unknown) => void;
  onSuccess?: (customer: ICustomer | null) => void;
};

export default function useFindCustomerById(params: TParams = {}) {
  const mutation = useMutation(
    (id: number) => makeFetchCustomerByIdUseCase().execute({ id }),
    { onSuccess: params.onSuccess, onError: params.onError },
  );

  return {
    loading: mutation.isLoading,
    find: mutation.mutateAsync,
  };
}
